import styled from 'styled-components';
export const Container = styled.div`
  position: absolute;
  display:${({visibility}) => visibility ?' ':'none'};
  /* visibility: ${({visibility}) => visibility ?' ':'hidden'}; */
  width: 100%;
  height:100%;
  overflow-y:auto;
  overflow-x:hidden;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`

export const NotRegister = styled.div`
  width: 100%;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #495057;
  background-color: #dfdede;
`